import React from "react";
// import Home from '../dashboard/AdminDashboard/Home';
import { useNavigate, useRoutes } from "react-router-dom";
import Dashboard from "../Home/Dashboard";
import AppIndex from "./AppIndex";
import LadinPage from "./LadinPage/LadinPage";
import WorldOutlook from "../Home/world-outlook";
import Overview from "../Home/world-outlook/Overview";
import IndicatorBreakdown from "../Home/world-outlook/IndicatorBreakdown";
import CountriesByIndicator from "../Home/world-outlook/CountriesByIndicator";
import AnnualChange from "../Home/regional-outlook/AnnualChange";

function AppNavigation() {
  let element = useRoutes([
    {
      path: "/dashboard",
      element: (
        <Dashboard
          region="Sub-Saharan Africa"
          type="Sub-Saharan Africa Regional Economic Outlook?(AFRREO)"
        />
      ),
      children: [{ index: true }],
    },
    {
      element: <AppIndex />,
      children: [
        {
          index: true,
          element: (
            <Dashboard
              region="Sub-Saharan Africa"
              type="Sub-Saharan Africa Regional Economic Outlook?(AFRREO)"
            />
          ),
        },
        {
          path: "/dashboard",
          element: (
            <Dashboard
              region="Sub-Saharan Africa"
              type="Sub-Saharan Africa Regional Economic Outlook?(AFRREO)"
            />
          ),
        },
        {
          path: "/world-bank",
          element: <Dashboard region="Sub-Saharan Africa" type="World Bank" />,
        },
        {
          path: "/annual-change",
          element: (
            <AnnualChange
              region="Sub-Saharan Africa"
              type="Sub-Saharan Africa Regional Economic Outlook?(AFRREO)"
            />
          ),
        },
        {
          path: "/world-outlook",
          element: (
            <WorldOutlook
              region="Sub-Saharan Africa"
              type_of_data="World Economic Outlook"
            />
          ),
          // children:[

          // ]
        },
        // {
        //   path: '/overview',
        //   // index:true,
        //   element: <Overview />
        // },
        {
          path: "/world-outlook/indicator-breakdown",
          element: <IndicatorBreakdown />,
        },
        {
          path: "/world-outlook/countries-by-indicator",
          element: <CountriesByIndicator />,
        },
        // {
        //     path: "/dashboard/regional-avg",
        //     element: <Dashboard region='west africa' type='African Economic Outlook'/>
        // }
      ],
    },
  ]);
  return element;
}
export default AppNavigation;
